var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMembersMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_10803",
    "data-name": "Grupo 10803",
    transform: "translate(1508 -186)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_17735",
    "data-name": "Rect\\xE1ngulo 17735",
    width: 30,
    height: 30,
    transform: "translate(-1508 186)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_open-person",
    "data-name": "Icon open-person",
    d: "M9,0C6.525,0,4.5,2.331,4.5,5.2s2.025,5.2,4.5,5.2,4.5-2.331,4.5-5.2S11.475,0,9,0ZM4.3,10.406A4.327,4.327,0,0,0,0,14.569V16.65H18V14.569a4.312,4.312,0,0,0-4.3-4.162A6.53,6.53,0,0,1,9,12.487,6.53,6.53,0,0,1,4.3,10.406Z",
    transform: "translate(-1501.967 192.675)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersMenu);
export default __webpack_public_path__ + "static/media/members-menu.29e74af6dd1a03971e71630bc7f76636.svg";
export { ForwardRef as ReactComponent };